import { LoginService } from '../services/rest/login.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { StorageService } from '../services/general-utils';
import { USER_DATA_KEY, AUTH_FAIR_VALUE, AUTH_PRICING, AUTH_SCOPERTURE } from 'src/app/shared/constants/app.constants';
import { UserService } from '../services/rest/user.service';
import { AccountService } from '../services/rest/account.service';
import { SpinnerService } from 'src/app/shared/components/spinner/spinner.service';
import { PasswordDimenticataDialogComponent } from './password-dimenticata-dialog/password-dimenticata-dialog.component';
import { PasswordScadutaDialogComponent } from './password-scaduta-dialog/password-scaduta-dialog.component';

@Component({
  selector: 'login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild('passwordDimenticataDialog') passwordDimenticataDialog: PasswordDimenticataDialogComponent;
  @ViewChild('passwordScadutaDialog') passwordScadutaDialog: PasswordScadutaDialogComponent;

  subscriptions: Subscription = new Subscription();
  formGroup: FormGroup;
  isSpinnerActivated: boolean;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private storageService: StorageService,
    private userService: UserService,
    private accountService: AccountService,
    private spinner: SpinnerService
  ) {
  }

  ngOnInit() {
    if (this.storageService.getItem(USER_DATA_KEY)) {
      this.router.navigate(['/homepage']);
    } else {
      this.createForm();
      this.isSpinnerActivated = false;
    }
  }

  createForm() {
    this.formGroup = new FormGroup({
      utente: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required)
    });
  }

  login() {
    const username = this.formGroup.controls['utente'].value;
    const password = this.formGroup.controls['password'].value;
    this.spinner.activate();
    this.isSpinnerActivated = true;
    this.subscriptions.add(this.loginService.login(username, password).subscribe({
      next: resp => {
        const now = new Date();
        let dataScadenzaPassword = null;
        const dsp = resp.body.user.dataScadenzaPassword;
        if (dsp) {
          dataScadenzaPassword = new Date(Number(dsp.substring(0,4)), Number(dsp.substring(4,6)) - 1, Number(dsp.substring(6,8)));
        }
        
        resp.body.qlikIds.apps.find(app => app.appName === 'Fair Value') ? this.storageService.setItem(AUTH_FAIR_VALUE, 'true') :
          this.storageService.removeItem(AUTH_FAIR_VALUE);
        resp.body.qlikIds.apps.find(app => app.appName === 'Pricing Derivati Cambi') ? this.storageService.setItem(AUTH_PRICING, 'true') :
          this.storageService.removeItem(AUTH_PRICING);
        resp.body.qlikIds.apps.find(app => app.appName === 'Simulazione.Scoperture') ? this.storageService.setItem(AUTH_SCOPERTURE, 'true') :
          this.storageService.removeItem(AUTH_SCOPERTURE);
        this.storageService.setItem(USER_DATA_KEY, JSON.stringify(resp.body));
        this.userService.updateUser(); // setta lo user nel service...
        this.accountService.identity(true);
        this.spinner.deactivate();
  
        if (!dataScadenzaPassword || now < dataScadenzaPassword) {
          this.router.navigate(['/homepage']);
        } else {
          this.isSpinnerActivated = false;
          this.passwordScadutaDialog.openDialog();
        }
      },
      error: error => {
        this.spinner.deactivate();
        this.isSpinnerActivated = false;
        throw error;
      }
    }));
  }

  openPasswordDimenticataDialog() {
    this.passwordDimenticataDialog.openDialog();
  }
}